/**
 * Checkout-related constants
 */

// V2 payment.enrollmentType uses the long form; the checkout store expects the short
// form. Null-prototype map so any unknown value becomes '' instead of leaking through.
export const ENROLLMENT_TYPE_LABELS = Object.assign(Object.create(null), {
  EnrollmentTypePartnerPay: 'PartnerPay',
  EnrollmentTypeLearnerPay: 'LearnerPay'
});

// Benefit types whose enrollments the partner covers; mirrors the checkout's prepaid gate.
export const PREPAID_ENROLLMENT_BENEFIT_TYPES = ['1', '2', '5'];
